import React from 'react'
import { useTenant } from '@emerald-works-nova/auth'
import B2BSignIn from './components/b2b-sign-in'
import B2CSignIn from './components/b2c-sign-in'

const SignInPage = () => {
  const tenant = useTenant()
  const isClubOrAdminTenant = ['www', 'admin'].includes(tenant?.tenantKey)

  return isClubOrAdminTenant ? <B2CSignIn tenant={tenant} /> : <B2BSignIn tenant={tenant} />
}

export {
  SignInPage as Component
}
